// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__39Z92","choiceBoxes":"toolbarselects_choiceBoxes__30acp","simpleField":"toolbarselects_simpleField__f_NIP"};